import React, { useState, useEffect } from 'react';
import './dashboard.css'; // Import the CSS file for custom styles

const Dashboard = () => {
    const [filters, setFilters] = useState({
        company: '',
        startDate: '',
        endDate: '',
    });

    const [data, setData] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false); // Added loading state

    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                const response = await fetch('https://reportingapi.headsupfortails.com/fetch-companies', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': 'jXmnIVuh5d2piSpWvslRS8sDbAWOz5nTaR2oq6dO'
                    },
                    body: JSON.stringify({
                        data: {}
                    }),
                });

                const result = await response.json();
                console.log("result============", result)
                setCompanies(result.data);
            } catch (error) {
                console.error('Error fetching companies:', error);
            }
        };

        fetchCompanies();
    }, []);

    const validateDates = () => {
        if (filters.startDate && filters.endDate) {
            const startDate = new Date(filters.startDate);
            const endDate = new Date(filters.endDate);
            return startDate <= endDate;
        }
        return true;
    };

    const validateFields = () => {
        // Check if all required fields are filled
        return filters.company && filters.startDate && filters.endDate && validateDates();
    };

    const fetchData = async () => {
        if (!validateFields()) {
            setErrorMessage('Start date must be earlier than end date');
            return;
        }

        setLoading(true); 

        try {
            const { company, startDate, endDate } = filters;
            const payload = {
                company: company.split(","),
                startDate,
                endDate
            };

            console.log("payload", payload);
            const response = await fetch('https://reportingapi.headsupfortails.com/fetch-and-export-data', {
                // huft-mobileapp-1021157604.ap-south-1.elb.amazonaws.com
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-key': 'jXmnIVuh5d2piSpWvslRS8sDbAWOz5nTaR2oq6dO' },
                body: JSON.stringify(payload),
                
            });

            const result = await response.json();
            console.log("response", response)
            if(response.ok){

                if (result && result.fileUrl) {
                    downloadFileFromS3(result.fileUrl);
                }
                setShowToast(true);
                setTimeout(() => setShowToast(false), 3000);
                setErrorMessage('');
                setFilters({company:'', startDate:'', endDate:''})
            }else{
                setErrorMessage('Error while fetching report');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); 
        }
    };

    const downloadFileFromS3 = (s3Url) => {
        const a = document.createElement('a');
        a.href = s3Url;
        a.download = s3Url.split('/').pop();  
        a.click();  
    };

    console.log("loading----------------------", loading)

    return (
        <div className="dashboard">

            <div className="logo-container">
                <img src="/santa_huft_logo.avif" alt="Huft Logo" className="logo" />
            </div>

            <div className="filters">
                <div className="filter-field">
                    <label htmlFor="company">Company</label>
                    <select
                        id="company"
                        value={filters.company}
                        onChange={(e) => setFilters({ ...filters, company: e.target.value })}
                        required
                    >
                        <option value="">Select a Company</option>
                        {Object.entries(companies).map(([key, values]) => (
                            <option value={values}>{key}</option>
                        ))}
                    </select>
                </div>
                <div className="filter-field">
                    <label htmlFor="startDate">Start Date</label>
                    <input
                        id="startDate"
                        type="date"
                        placeholder="Start Date"
                        value={filters.startDate}
                        required
                        onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                    />
                </div>
                <div className="filter-field">
                    <label htmlFor="endDate">End Date</label>
                    <input
                        id="endDate"
                        type="date"
                        placeholder="End Date"
                        value={filters.endDate}
                        required
                        onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                    />
                </div>
                <button className="fetch-button" onClick={fetchData}>
                    Fetch Report
                </button>
            </div>

            {loading && (
                <>
                    <div className="overlay"></div>
                    <div className="loader">
                        <div className="spinner"></div>
                    </div>
                </>
            )}
            
            {errorMessage && <div className="error-message">{errorMessage}</div>}

            {showToast && <div className="toast">Data fetched successfully!</div>}

            {data && <a href={data.excelUrl} download="report.xlsx">Download Report</a>}
        </div>
    );
};

export default Dashboard;
